<template>
    <div class="parking-tabs">
        <div v-show="isActiveList" class="parking-tabs__content">
            <ParkingList />
        </div>
        <div v-show="isActiveVisual" class="parking-tabs__content-visual">
            <Canvas modify="visual-canvas__page-parking"/>
        </div>
    </div>
</template>

<style lang='scss'>
    @import "./Results.scss";
</style>


<script>
import {mapActions, mapGetters} from 'vuex';
import Canvas from '../../Canvas/Canvas';
import Observer from 'common/scripts/observer';
import ParkingList from '../ParkingList/ParkingList.vue';

const observer = new Observer();

export default {
    data: () => {
        return {
            isActiveVisual: window.innerWidth >= 960,
            isActiveList  : window.innerWidth < 960
        };
    },

    components: {
        ParkingList,
        Canvas
    },

    mounted() {
        this.subscribes();

        if (window.innerWidth < 960) {
            this.changeStatePinch(false);
            observer.publish('clickTabList');
        }
    },

    computed: {
        ...mapGetters({
            numberOfItems: 'GET_NUMBER_OF_ITEMS'
        })
    },

    methods: {
        ...mapActions(['changeStatePinch']),

        subscribes() {
            observer.subscribe('clickTabVisual', () => {
                this.isActiveVisual = true;
                this.isActiveList = false;
            });

            observer.subscribe('clickTabList', () => {
                this.isActiveList = true;
                this.isActiveVisual = false;
            });
        }
    }
};
</script>
